import { getTranslation } from "@/features/questionnaire/utils";
import { Pill } from "@repo/skapa";
import { useSettings } from "@repo/ui";

import { type QuestionsProps } from "../types";

export const ColorQuestion = ({
  answer,
  onAnswerIdAnswered,
  question,
}: QuestionsProps) => {
  const { language } = useSettings();

  const handleButtonClick = (answerId: any) => {
    const selectedAnswerIds = answer?.answerIds || [];
    const updatedSelectedIds = selectedAnswerIds.includes(answerId)
      ? selectedAnswerIds.filter((id: any) => id !== answerId)
      : [...selectedAnswerIds, answerId];

    onAnswerIdAnswered?.(updatedSelectedIds);
  };

  const getIcon = (color: string) => {
    return () => {
      const i = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="25"
          viewBox="0 0 100 100"
        >
          <circle cx="50" cy="50" r="30" fill={color} />
        </svg>
      );

      return [i];
    };
  };

  const selectedAnswerIds = answer?.answerIds || [];

  if (!question?.answers) {
    return null;
  }

  return (
    <div>
      {question.answers.map((option) => (
        <Pill
          key={`${question.question_id_key}-${option.answer_id_key}`}
          label={getTranslation(
            option.answer_translation ?? [],
            language,
            option.answer_name
          )}
          selected={selectedAnswerIds.includes(option.answer_id_key)}
          className="demo-pill--in-carousel-story"
          onClick={() => handleButtonClick(option.answer_id_key)}
          size="small"
          leadingIcon={getIcon(option.answer_mediaSource ?? "")}
          style={{ margin: "4px" }}
        />
      ))}
    </div>
  );
};
